<script>

  import { onMount } from "svelte";

  let local;

  onMount(async () => {
    const res = await fetch(`./data/footer.json`);
    local = await res.json();
  })

  // fetch("./data/footer.json")
  //   .then(res => {
  //     console.log('res', res)
  //     return res.json();
  //   })
  //   .then(data => {
  //     console.log(data)
  //     local = data;
  //   })
</script>

<div class="ftr dark" data-section="ftr">
  <div class="layout grid">
    {#if local && local.status}
      {#each local.cols as col}
      <div>
        {@html col}
      </div>
      {/each}
    {:else}
      <p class="loading">loading..</p>
    {/if}
  </div>
</div>

<style>
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    column-gap: 40px;
  }
  @media screen and (min-width: 600px) {
    .grid {
      grid-template-columns: 2fr 1fr;
      column-gap: 40px;
    }
  }
</style>